export default __webpack_public_path__ + "static/media/dustbin.c2847be5.svg";